<div
  class="agent-interview-slot-wrapper d-flex align-items-center justify-content-between"
  style="border-color: #24b89b; background-color: #e7fffa; position: absolute; top: -82px; left: 0; right: 0; "
  [ngStyle]="scheduledCount < terminAgentsCount ? { 'border-color': '#af1c3d', 'background-color': '#ffe3ea', 'position': 'absolute', 'top': '-82px', 'left': '0', 'right': '0' } : { 'border-color': '#24b89b', 'background-color': '#e7fffa', 'position': 'absolute', 'top': '-82px', 'left': '0', 'right': '0' }"
  *ngIf="headerText.display === 'Termin gewünscht / vereinbart' && !headerText.collapsed && (currentRole == 'Admin' || currentRole == 'Client') && isVgProject"
  (click)="dialogService.showTimeSlotDialog = true"
>
  <div class="d-flex align-items-center gap-3">
    <div style="color: #24b89b" [ngStyle]="scheduledCount < terminAgentsCount ? {color: '#af1c3d'} : {color: '#24b89b'}">
      <svg
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="currentColor"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        id="screenshot-784c5983-b509-808f-8003-ecc640384bb8"
        version="1.1"
        viewBox="6880.647 705.571 17.131 15"
        height="20"
      >
        <g id="shape-784c5983-b509-808f-8003-ecc640384bb8">
          <g class="fills" id="fills-784c5983-b509-808f-8003-ecc640384bb8">
            <path
              rx="0"
              ry="0"
              fill="currentColor"
              d="M6888.356,720.571L6888.356,718.904L6895.209,718.904L6895.209,712.987C6895.209,711.362,6894.627,709.984,6893.464,708.852C6892.301,707.721,6890.884,707.155,6889.213,707.154C6887.543,707.154,6886.126,707.720,6884.963,708.852C6883.800,709.985,6883.218,711.363,6883.217,712.987L6883.217,718.071L6880.647,718.071L6880.647,713.300L6881.504,713.300L6881.568,712.196C6881.682,711.251,6881.965,710.376,6882.414,709.571C6882.864,708.765,6883.428,708.064,6884.106,707.467C6884.784,706.869,6885.562,706.404,6886.439,706.071C6887.317,705.737,6888.242,705.571,6889.213,705.571C6890.184,705.571,6891.105,705.737,6891.975,706.071C6892.846,706.404,6893.624,706.866,6894.310,707.457C6894.995,708.047,6895.559,708.744,6896.001,709.550C6896.444,710.355,6896.729,711.230,6896.858,712.175L6896.922,713.300L6897.779,713.300L6897.779,718.071L6896.922,718.071L6896.922,720.571ZM6886.643,714.737C6886.401,714.737,6886.197,714.657,6886.033,714.497C6885.870,714.337,6885.787,714.140,6885.787,713.904C6885.787,713.668,6885.869,713.470,6886.033,713.311C6886.198,713.151,6886.401,713.071,6886.643,713.071C6886.886,713.071,6887.090,713.151,6887.254,713.311C6887.419,713.471,6887.500,713.669,6887.500,713.904C6887.500,714.140,6887.418,714.338,6887.253,714.498C6887.089,714.658,6886.885,714.738,6886.643,714.737ZM6891.783,714.737C6891.540,714.737,6891.337,714.657,6891.173,714.497C6891.009,714.337,6890.927,714.140,6890.926,713.904C6890.926,713.668,6891.008,713.470,6891.173,713.311C6891.337,713.151,6891.541,713.071,6891.783,713.071C6892.025,713.071,6892.229,713.151,6892.393,713.311C6892.558,713.471,6892.640,713.669,6892.639,713.904C6892.639,714.140,6892.557,714.338,6892.393,714.498C6892.228,714.658,6892.025,714.738,6891.783,714.737ZM6884.095,713.446C6883.995,711.974,6884.452,710.710,6885.466,709.654C6886.479,708.599,6887.743,708.071,6889.256,708.071C6890.526,708.071,6891.644,708.463,6892.608,709.247C6893.571,710.032,6894.153,711.036,6894.352,712.259C6893.053,712.245,6891.858,711.904,6890.766,711.237C6889.674,710.571,6888.835,709.668,6888.249,708.529C6888.021,709.640,6887.539,710.630,6886.804,711.498C6886.069,712.367,6885.166,713.016,6884.095,713.446Z"
            ></path>
          </g>
        </g>
      </svg>
    </div>
    <div>
      <p class="mb-2 time-slot slot-duration">Slotdauer - 30 Min.</p>
      <p class="mb-0 time-slot interview-slot-duration">
        Agent Interview Zeitfenster
      </p>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-end flex-column" style="row-gap: 16px;">
        <svg
          xmlns:xlink="http://www.w3.org/1999/xlink"
          fill="none"
          width="12"
          xmlns="http://www.w3.org/2000/svg"
          id="screenshot-ef797324-95d0-8004-8003-ecec15a44ff8"
          version="1.1"
          viewBox="7245 3254 8 8"
          height="12"
        >
          <g id="shape-ef797324-95d0-8004-8003-ecec15a44ff8">
            <g class="fills" id="fills-ef797324-95d0-8004-8003-ecec15a44ff8">
              <path
                rx="0"
                ry="0"
                fill="currentColor"
                d="M7247.000,3255.000C7246.448,3255.000,7246.000,3255.448,7246.000,3256.000L7246.000,3260.000C7246.000,3260.552,7246.448,3261.000,7247.000,3261.000L7251.000,3261.000C7251.552,3261.000,7252.000,3260.552,7252.000,3260.000L7252.000,3259.000C7252.000,3258.724,7252.224,3258.500,7252.500,3258.500C7252.776,3258.500,7253.000,3258.724,7253.000,3259.000L7253.000,3260.000C7253.000,3261.105,7252.105,3262.000,7251.000,3262.000L7247.000,3262.000C7245.895,3262.000,7245.000,3261.105,7245.000,3260.000L7245.000,3256.000C7245.000,3254.895,7245.895,3254.000,7247.000,3254.000L7248.000,3254.000C7248.276,3254.000,7248.500,3254.224,7248.500,3254.500C7248.500,3254.776,7248.276,3255.000,7248.000,3255.000ZM7250.000,3255.000C7249.724,3255.000,7249.500,3254.776,7249.500,3254.500C7249.500,3254.224,7249.724,3254.000,7250.000,3254.000L7252.500,3254.000C7252.776,3254.000,7253.000,3254.224,7253.000,3254.500L7253.000,3257.000C7253.000,3257.276,7252.776,3257.500,7252.500,3257.500C7252.224,3257.500,7252.000,3257.276,7252.000,3257.000L7252.000,3255.707L7250.354,3257.354C7250.158,3257.550,7249.842,3257.550,7249.646,3257.354C7249.450,3257.158,7249.450,3256.842,7249.646,3256.646L7251.293,3255.000Z"
              ></path>
            </g>
          </g>
        </svg>
    <p class="mb-0" style="color: #24b89b" [ngStyle]="scheduledCount < terminAgentsCount ? {color: '#af1c3d'} : {color: '#24b89b'}">{{terminAgentsCount}} von {{scheduledCount}}</p>
  </div>
</div>

<div class="drag-and-drop-card-list-container" [ngClass]="{collapse: headerText.collapsed}">
  <div class="drag-and-drop-card-list-header">
    <div class="card-header">
      <p class="mb-2 text-capitalize">Status</p>
      <span class="list-header" *ngIf="currentRole !== 'Client'">{{ headerText.display }}</span>
      <span class="list-header" *ngIf="currentRole === 'Client'">{{ headerText.customerDisplayName || headerText.display }}</span>
    </div>
    <div>
      <div class="leftAngle" (click)="headerText.collapsed = true" *ngIf="!headerText.collapsed">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          class="d-flex"
          height="16"
          width="16"
          fill="currentColor"
        >
          <path
            d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
          />
        </svg>
      </div>
      <div class="rightAngle" (click)="headerText.collapsed = false" *ngIf="headerText.collapsed">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          class="d-flex"
          height="16"
          width="16"
          fill="currentColor"
        >
          <path
            d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
          />
        </svg>
      </div>
    </div>
  </div>

  <div
    class="drag-and-drop-card-list"
    (dragover)="allowDrop($event)"
    (drop)="onDrop($event)"
  >
    <drag-and-drop-card
      *ngFor="let entry of data"
      [data]="entry"
      [cardTemplate]="cardTemplate"
      [draggable]="currentRole !== 'Partner'"
      (dragstart)="currentRole !== 'Partner'?onDragStart($event, entry):null"
    ></drag-and-drop-card>
    @if(isSpinnerActive) {
      <app-spinner class="spinner"></app-spinner>
    }
  </div>
</div>
